import '.cf{position:relative;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.g9{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.c3{align-items:flex-start;}.ssr-plugin'
import '.s{padding:2rem;}.ssr-plugin'
import '.cl{background:var(--shades-white);}.ssr-plugin'
import '.p{overflow:hidden;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.ib{top:50%;}.ssr-plugin'
import '.ic{right:1rem;}.ssr-plugin'
import '.id{transform:translateY(-50%);}.ssr-plugin'
import '.ie{width:120px;}.ssr-plugin'
import '.if{height:120px;}.ssr-plugin'
import '.ig{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.h5{z-index:1;}.ssr-plugin'
import '.bb{gap:0.5rem;}.ssr-plugin'
import '.ih{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="cf z g9 a b g c3 s cl p"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="l ib ic id ie if ig a c g"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="cf h5 a b c3 bb ih"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
